import { ProductAffiliateResponseDTO, ProductResponseDTO } from "@shared/DTO";
import { getMountDefinition, MountDefinition } from "@shared/values";

type LensAffiliateProduct = Pick<ProductResponseDTO, 'lensData' | 'affiliate'>;

export interface LensMountAffiliate {
  mount: MountDefinition;
  affiliate: ProductAffiliateResponseDTO | undefined;
}

export const getLensMountAffiliates = (
  lens: LensAffiliateProduct,
): LensMountAffiliate[] => {
  return (lens?.lensData?.mounts ?? [])
    .map(({ mount, affiliateReference }) => {
      const mountDefinition = getMountDefinition(mount);
      const affiliate = lens.affiliate?.find(({ reference }) =>
        affiliateReference?.includes(reference),
      );
      return { mount: mountDefinition, affiliate };
    })
    .filter((rule): rule is LensMountAffiliate => !!rule.mount);
};
